import colors from "app/colors";
import type Quill from "quill";

export const highlightSearchTerms = (quill: Quill, searchTerms: string[]) => {
  const text = quill.getText();

  searchTerms.forEach((term) => {
    if (!term) return;
    const lowerText = text.toLowerCase();
    const lowerTerm = term.toLowerCase();
    let index = lowerText.indexOf(lowerTerm);

    while (index !== -1) {
      quill.formatText(
        index,
        term.length,
        "background",
        colors.yellow,
        "silent",
      );
      index = lowerText.indexOf(lowerTerm, index + term.length);
    }
  });
};
